module.exports = __webpack_public_path__ + "img/instagram.17f40000.svg";